import { render } from "./HiStage.vue?vue&type=template&id=57fbe81a"
import script from "./HiStage.vue?vue&type=script&lang=js"
export * from "./HiStage.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__